import React, { createContext, useContext, useState } from "react";

interface SelectedDeviceContextType {
  selectedDeviceId: string | null;
  setSelectedDeviceId: React.Dispatch<React.SetStateAction<string | null>>;
}

const SelectedDeviceContext = createContext<SelectedDeviceContextType | undefined>(undefined);

export const SelectedDeviceProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedDeviceId, setSelectedDeviceId] = useState<string | null>(null);

  return (
    <SelectedDeviceContext.Provider value={{ selectedDeviceId, setSelectedDeviceId }}>
      {children}
    </SelectedDeviceContext.Provider>
  );
};

export const useSelectedDevice = () => {
  const context = useContext(SelectedDeviceContext);
  if (!context) {
    throw new Error("useSelectedDevice precisa estar dentro do SelectedDeviceProvider");
  }
  return context;
};

